/**
 * Bottom status bar showing details about the currently selected rack(s).
 */

import React from 'react';
import { Box } from 'lucide-react';
import { useLayoutEditor } from '../contexts/LayoutEditorContext';

const SelectionStatusBar: React.FC = () => {
  const { state, rackDimensionsMap } = useLayoutEditor();
  const { layout, editorState } = state;

  if (!layout || editorState.selectedRacks.size === 0) return null;

  if (editorState.selectedRacks.size === 1) {
    const rackNumber = Array.from(editorState.selectedRacks)[0];
    const rack = layout.racks.find(r => r.rackNumber === rackNumber);
    const dim = rackDimensionsMap.get(rackNumber);

    return (
      <div className="bg-white border-t border-gray-200 px-4 py-2">
        <div className="flex items-center gap-4">
          <Box className="w-5 h-5 text-blue-600" />
          <span className="font-medium">Reol {rackNumber}</span>
          {rack && dim && (
            <>
              <span className="text-gray-500">&bull;</span>
              <span className="text-sm text-gray-600">
                Posisjon: ({rack.x.toFixed(1)}m, {rack.y.toFixed(1)}m)
              </span>
              <span className="text-gray-500">&bull;</span>
              <span className="text-sm text-gray-600">
                Storrelse: {dim.width.toFixed(1)}m &times; {dim.depth.toFixed(1)}m &times; {dim.height.toFixed(1)}m
              </span>
              <span className="text-gray-500">&bull;</span>
              <span className="text-sm text-gray-600">
                Rotasjon: {rack.rotation}&deg;
              </span>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border-t border-gray-200 px-4 py-2">
      <div className="flex items-center gap-4">
        <Box className="w-5 h-5 text-blue-600" />
        <span className="font-medium">{editorState.selectedRacks.size} reoler valgt</span>
        <span className="text-gray-500">&bull;</span>
        <span className="text-sm text-gray-600">
          Trykk R for å rotere alle, Delete for å slette
        </span>
      </div>
    </div>
  );
};

export default SelectionStatusBar;
